function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = this && this.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    align-self: center;\n    margin-bottom: 1.5rem;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    margin-bottom: 24px;\n    @media (max-width: 600px) {\n      flex-direction: row;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  svg {\n    margin-right: 8px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "Minimum 8 characters"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "Contains 1 letter"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "Contains 1 number"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "Contains 1 special character"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "Your password has been updated successfully."
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "Unexpected error while setting a new password."
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "Oops! Something went wrong. Please check your email or try resetting your password again."
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "Reset Password"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "Return to Login"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "Please address the errors shown below"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "Set a New Password"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "Password"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "Password is required."
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "Confirm New Password"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "Password is required."
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "Passwords must match."
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "Setting New Password..."
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "Set New Password"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "Return to Login"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Button, Form as AntForm, Space, Input, message, Popover, Typography } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone, WarningFilled, CheckCircleFilled } from "@ant-design/icons";
import { t } from "ttag";
import { useHistory } from "react-router-dom";
import useSearchParams from "../../../hooks/useSearchParams";
import useTranslation from "../../../hooks/useTranslation";
import Label from "../../Label";
import Layout from "../Layout";
var AntTitle = Typography.Title, Text = Typography.Text;
var useForm = AntForm.useForm;
var ONE_LETTER_REGEX = /[a-zA-Z]/;
var ONE_NUMBER_REGEX = /[0-9]/;
var ONE_SPECIAL_CHARACTER_REGEX = /[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/;
var EIGHT_CHARACTERS_REGEX = /.{8}/;
var Title = styled(AntTitle)(_templateObject());
var Form = styled(AntForm)(_templateObject1());
var Field = styled(AntForm.Item)(_templateObject2());
var Check = styled.div(_templateObject3(), function(param) {
    var isValid = param.isValid;
    return isValid ? "#6EBB83" : "#ff4d4f";
});
var validatePassword = function(password) {
    var hasLetter = !!password.match(ONE_LETTER_REGEX);
    var hasNumber = !!password.match(ONE_NUMBER_REGEX);
    var hasSpecialCharacter = !!password.match(ONE_SPECIAL_CHARACTER_REGEX);
    var hasEightCharacters = !!password.match(EIGHT_CHARACTERS_REGEX);
    var isValid = password && hasLetter && hasNumber && hasSpecialCharacter && hasEightCharacters;
    return {
        hasLetter: hasLetter,
        hasNumber: hasNumber,
        hasSpecialCharacter: hasSpecialCharacter,
        hasEightCharacters: hasEightCharacters,
        isValid: isValid
    };
};
var PasswordCheck = function(param) {
    var children = param.children, isValid = param.isValid;
    return /*#__PURE__*/ React.createElement(Check, {
        isValid: isValid
    }, isValid && /*#__PURE__*/ React.createElement(CheckCircleFilled, null), !isValid && /*#__PURE__*/ React.createElement(WarningFilled, null), children);
};
var PasswordInstructions = function(param) {
    var password = param.password;
    var _validatePassword = validatePassword(password), hasEightCharacters = _validatePassword.hasEightCharacters, hasLetter = _validatePassword.hasLetter, hasNumber = _validatePassword.hasNumber, hasSpecialCharacter = _validatePassword.hasSpecialCharacter;
    return /*#__PURE__*/ React.createElement("div", {
        "data-testid": "passwordInstructions"
    }, /*#__PURE__*/ React.createElement(PasswordCheck, {
        isValid: hasEightCharacters
    }, t(_templateObject4())), /*#__PURE__*/ React.createElement(PasswordCheck, {
        isValid: hasLetter
    }, t(_templateObject5())), /*#__PURE__*/ React.createElement(PasswordCheck, {
        isValid: hasNumber
    }, t(_templateObject6())), /*#__PURE__*/ React.createElement(PasswordCheck, {
        isValid: hasSpecialCharacter
    }, t(_templateObject7())));
};
var PasswordField = function(_param) /*#__PURE__*/ {
    var value = _param.value, onChange = _param.onChange, showInstructions = _param.showInstructions, rest = _objectWithoutProperties(_param, [
        "value",
        "onChange",
        "showInstructions"
    ]);
    return React.createElement(Popover, {
        open: showInstructions,
        placement: "bottomLeft",
        content: /*#__PURE__*/ React.createElement(PasswordInstructions, {
            password: value
        })
    }, /*#__PURE__*/ React.createElement(Input.Password, _extends({
        value: value,
        "data-testid": "password",
        onChange: onChange
    }, rest)));
};
var useValidateToken = function(token, validateTokenFn) {
    var _useState = _slicedToArray(useState(false), 2), loading = _useState[0], setLoading = _useState[1];
    var _useState1 = _slicedToArray(useState(false), 2), error = _useState1[0], setError = _useState1[1];
    useEffect(function() {
        var effect = function() {
            var _ref = _asyncToGenerator(function() {
                var e;
                return __generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setLoading(true);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                4,
                                5
                            ]);
                            return [
                                4,
                                validateTokenFn(token)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 3:
                            e = _state.sent();
                            setError(true);
                            return [
                                3,
                                5
                            ];
                        case 4:
                            setLoading(false);
                            return [
                                7
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function effect() {
                return _ref.apply(this, arguments);
            };
        }();
        if (token) {
            effect();
        } else {
            setError(true);
        }
    }, [
        token,
        validateTokenFn
    ]);
    return {
        loading: loading,
        error: error
    };
};
var visibilityIcon = function(visible) {
    return visible ? /*#__PURE__*/ React.createElement(EyeTwoTone, null) : /*#__PURE__*/ React.createElement(EyeInvisibleOutlined, null);
};
var ResetPassword = function(param) {
    var validateTokenFn = param.validateTokenFn, resetPasswordFn = param.resetPasswordFn, _param_afterReset = param.afterReset, afterReset = _param_afterReset === void 0 ? null : _param_afterReset, _param_showReturnToLogin = param.showReturnToLogin, showReturnToLogin = _param_showReturnToLogin === void 0 ? false : _param_showReturnToLogin;
    var _useForm = _slicedToArray(useForm(), 1), form = _useForm[0];
    var validateFields = form.validateFields, getFieldValue = form.getFieldValue;
    var _useState = _slicedToArray(useState(false), 2), loading = _useState[0], setLoading = _useState[1];
    var _useState1 = _slicedToArray(useState(false), 2), inputFocus = _useState1[0], setInputFocus = _useState1[1];
    var _useState2 = _slicedToArray(useState(false), 2), showPasswordPopup = _useState2[0], setShowPasswordPopup = _useState2[1];
    var history = useHistory();
    var query = useSearchParams();
    var token = query === null || query === void 0 ? void 0 : query.get("token");
    useTranslation();
    var _useValidateToken = useValidateToken(token, validateTokenFn), error = _useValidateToken.error, validatingToken = _useValidateToken.loading;
    var handleOnFocus = function() {
        setShowPasswordPopup(true);
        setInputFocus(true);
    };
    var handleOnBlur = function() {
        setShowPasswordPopup(false);
        setInputFocus(false);
    };
    var onFinish = function() {
        var _ref = _asyncToGenerator(function() {
            var values, payload, e;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        return [
                            4,
                            validateFields()
                        ];
                    case 1:
                        values = _state.sent();
                        payload = {
                            password: values.password,
                            token: token
                        };
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            5,
                            6
                        ]);
                        return [
                            4,
                            resetPasswordFn(payload)
                        ];
                    case 3:
                        _state.sent();
                        message.success(t(_templateObject8()));
                        if (afterReset) {
                            afterReset();
                        }
                        return [
                            3,
                            6
                        ];
                    case 4:
                        e = _state.sent();
                        // TODO: handle API error handling when integrating with CP or EXP
                        message.error(t(_templateObject9()));
                        return [
                            3,
                            6
                        ];
                    case 5:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function onFinish() {
            return _ref.apply(this, arguments);
        };
    }();
    if (error) {
        return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(Space, {
            direction: "vertical",
            size: "middle"
        }, /*#__PURE__*/ React.createElement(Text, null, t(_templateObject10())), /*#__PURE__*/ React.createElement(Button, {
            style: {
                width: "100%"
            },
            onClick: window.location.reload
        }, t(_templateObject11())), showReturnToLogin && /*#__PURE__*/ React.createElement(Button, {
            style: {
                width: "100%"
            },
            type: "primary",
            onClick: function() {
                return history.replace("/");
            }
        }, t(_templateObject12()))));
    }
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(Form, {
        form: form,
        onFinish: onFinish,
        layout: "vertical",
        hideRequiredMark: true,
        onFinishFailed: function() {
            return message.error(t(_templateObject13()));
        },
        initialValues: {
            password: "",
            confirmPassword: ""
        }
    }, /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Title, {
        level: 4
    }, t(_templateObject14())), /*#__PURE__*/ React.createElement(Field, {
        label: /*#__PURE__*/ React.createElement(Label, {
            isRequired: true
        }, t(_templateObject15())),
        name: "password",
        validateTrigger: [
            "onChange",
            "onFocus",
            "onBlur"
        ],
        rules: [
            {
                required: true,
                message: t(_templateObject16())
            },
            {
                validator: function(_, value) {
                    var isValid = validatePassword(value).isValid;
                    if (isValid) {
                        setShowPasswordPopup(false);
                        return Promise.resolve();
                    }
                    if (inputFocus) {
                        setShowPasswordPopup(true);
                    }
                    return Promise.reject(new Error(""));
                }
            }
        ]
    }, /*#__PURE__*/ React.createElement(PasswordField, {
        showInstructions: showPasswordPopup,
        onFocus: handleOnFocus,
        onBlur: handleOnBlur
    })), /*#__PURE__*/ React.createElement(Field, {
        label: /*#__PURE__*/ React.createElement(Label, {
            isRequired: true
        }, t(_templateObject17())),
        name: "confirmPassword",
        rules: [
            {
                required: true,
                message: t(_templateObject18())
            },
            {
                validator: function(_, value) {
                    if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                    }
                    return Promise.reject(new Error(t(_templateObject19())));
                }
            }
        ]
    }, /*#__PURE__*/ React.createElement(Input.Password, {
        "data-testid": "confirmPassword",
        iconRender: visibilityIcon
    })), /*#__PURE__*/ React.createElement(Field, {
        shouldUpdate: true,
        noStyle: true
    }, function() {
        return /*#__PURE__*/ React.createElement(Button, {
            type: "primary",
            htmlType: "submit",
            loading: loading,
            disabled: loading || !(getFieldValue("password") && getFieldValue("confirmPassword")) || validatingToken,
            style: {
                marginBottom: "16px"
            }
        }, loading ? t(_templateObject20()) : t(_templateObject21()));
    }), showReturnToLogin && /*#__PURE__*/ React.createElement(Button, {
        onClick: function() {
            return history.replace("/");
        }
    }, t(_templateObject22())))));
};
export default ResetPassword;
